import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

export interface EmbeddedVideo {
  id?: string;
  type: string;
  url: string;
  title?: string;
}

export interface ApiResponse<T> {
  statusCode: number;
  data: {
    success: boolean;
    message: string;
    data: T;
  };
}

@Injectable({
  providedIn: 'root'
})
export class EmbeddedVideoService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/configurations/embeddedVideos`;

  getVideos(): Observable<EmbeddedVideo[]> {
    return this.http.get<any>(this.apiUrl)
      .pipe(
        map((response: any) => {
          if (response && response.data) {
            return response.data;
          }
          return [];
        })
      );
  }

  createVideo(video: EmbeddedVideo): Observable<ApiResponse<EmbeddedVideo>> {
    return this.http.post<ApiResponse<EmbeddedVideo>>(this.apiUrl, video);
  }

  updateVideo(video: EmbeddedVideo): Observable<ApiResponse<EmbeddedVideo>> {
    return this.http.put<ApiResponse<EmbeddedVideo>>(this.apiUrl, video);
  }

  deleteVideo(type: string): Observable<ApiResponse<any>> {
    return this.http.delete<ApiResponse<any>>(`${this.apiUrl}?type=${type}`);
  }
} 